import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { includes, mergeRight } from "ramda";
import { getOptimizedPdfUrl } from "../creator-application/content/contentServices";

export const HIDE_VIEWER = "media-viewer/HIDE_VIEWER";
export const SHOW_VIEWER = "media-viewer/SHOW_VIEWER";

export const VIEWER_EPUB = "media-viewer/VIEWER_EPUB";
export const VIEWER_PDF = "media-viewer/VIEWER_PDF";
export const VIEWER_IMAGE = "media-viewer/VIEWER_IMAGE";
export const VIEWER_IMAGE_BOOK = "media-viewer/VIEWER_IMAGE_BOOK";
export const VIEWER_AUDIO = "media-viewer/VIEWER_AUDIO";
export const VIEWER_VIDEO = "media-viewer/VIEWER_VIDEO";

export const getViewerTypeForMedia = media => {
  const { mimeType, type, optimizedPdfUrl } = media;

  if (
    mimeType === "application/biblioboard+compound_content" &&
    type !== "ALBUM"
  ) {
    return null;
  }

  if (mimeType === "application/epub+zip") {
    return VIEWER_EPUB;
  }

  if (mimeType === "audio/mpeg" || type === "ALBUM") {
    return VIEWER_AUDIO;
  }

  if (mimeType === "video/mp4") {
    return VIEWER_VIDEO;
  }

  if (type === "IMAGE") {
    return VIEWER_IMAGE;
  }

  if (includes(type, ["ARTICLE", "BOOK", "CHAPTER", "OTHER_DOCUMENT"])) {
    if (type === "OTHER_DOCUMENT" && mimeType.startsWith("image/")) {
      return VIEWER_IMAGE;
    }

    return optimizedPdfUrl ? VIEWER_PDF : VIEWER_IMAGE_BOOK;
  }

  throw new Error(
    `No viewer type found for content type: ${type} and mime type: ${mimeType}`,
  );
};

const initialState = {
  openViewer: null,
  media: null,
};

export const useHandleOpenViewerClick = () => {
  const dispatch = useDispatch();
  const [isViewerLoading, setIsViewerLoading] = useState(false);

  const handleOpenViewerClick = useCallback(
    async content => {
      setIsViewerLoading(true);
      const optimizedPdfUrl = await getOptimizedPdfUrl(content);
      dispatch({
        type: SHOW_VIEWER,
        media: mergeRight(content, { optimizedPdfUrl }),
      });
      setIsViewerLoading(false);
    },
    [dispatch],
  );

  return { handleOpenViewerClick, isViewerLoading };
};

export const mediaViewerReducer = (state = initialState, action) => {
  switch (action.type) {
    case HIDE_VIEWER:
      return {
        ...state,
        openViewer: null,
        media: null,
      };
    case SHOW_VIEWER:
      return {
        ...state,
        openViewer: getViewerTypeForMedia(action.media),
        media: action.media,
      };
    default:
      return state;
  }
};
